import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import InfoBlock, { InformationBlock } from 'ah-common-lib/src/common/components/InfoBlock.vue';
import { Client, Individual } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactDetailsReview',
  props: {
    applicant: null,
    client: null
  },
  setup(__props: any) {

const props = __props as { applicant: Individual; client: Client };



const infoBlock = ref<InformationBlock[]>([
  { label: 'Title', key: 'title', cols: 4 },
  { label: 'Name', key: 'firstName', cols: 4 },
  { label: 'Surname', key: 'lastName', cols: 4 },
  { label: 'Email Address', key: 'email', cols: 4 },
  { label: 'Mobile Number', key: 'phoneNumber', cols: 4 },
  { label: 'Job Title', key: 'jobTitle', cols: 4 },
  { label: 'Where Did you Hear From Us?', key: 'reference', cols: 4 },
]);

const model = { ...props.applicant, reference: props.client.questionnaireAnswer };

return { __sfc: true,props, infoBlock, model, InfoBlock }
}

})